import { useEffect, useState } from "react";
import { ResolveUrl, ResolvePath, ResolveStorageUrl, GetCachedUrls } from "features/firebase-app";
import { makeCancelable } from "./util";
import RedQuickVideo from "./RedQuickVideo";

export default function RedQuickMovie(props: any) {
    const [source, setSource] = useState(null);
    useEffect(() => {
        if (props.src) {
            setSource(GetCachedUrls(props.src) || props.src);
            if (!GetCachedUrls(props.src)) {
                makeCancelable(ResolveStorageUrl(props.src).then((res) => {
                    if (res)
                        setSource(res);
                }));
            }
        }
    }, [props.src, GetCachedUrls(props.src)]);
    let args = { ...props };
    delete args.src;

    return <RedQuickVideo url={source} {...args} />
}

